<template>
    <!-- TODO css -->
    <modal @close="modals.marketplaceProductModal = false" :width="1000">
        <div id="product-modal" :class="loaded?'type-'+item.type:''">
            <div id="product-modal-left">
                <div v-if="loaded" class="product-image" :style="'background-image: url('+item.image_url+')'"></div>
            </div>
            <div id="product-modal-right">
                <div v-if="loaded" class="product-modal-right-content">
                    <h3>{{ item.name }}</h3>
                    <div class="product-by">{{ item.brand_name }}</div>
                    <div class="product-info" v-html="item.description"></div>
                    
                    <div class="actions">
                        <div class="price">
                            <div class="product-price" v-if="item.type == 'physical'">{{ item.price_ex_vat | toCurrency }}</div>
                          
                            <div class="product-price full" v-else-if="item.type=='voucher' && item.face_value_limits" >
                                <span>Available in any value from <b>{{ item.face_value_limits.lower | toCurrency }}</b> to <b>{{ item.face_value_limits.upper | toCurrency }}</b></span>
                            </div>    
                            <div class="product-price full" v-else-if="item.type=='voucher' && item.denominations" >
                                <span>Available values: <span v-for="denomination in item.denominations"><b>{{ denomination | toCurrency }}</b>, </span></span>
                            </div>    
                            
                            <div class="product-price-inc-vat" v-if="item.type == 'physical'">{{ item.price | toCurrency }} inc. VAT</div>
                        </div>
                        <div class="buttons">
                            <span v-if="team.corporation_id != 5" @click="openSendModal(item.id?item.id:item.slug)" class="ws-button ws-button-main" v-tooltip="'Choose the gift on behalf of the recipient and we\'ll send it directly to them.'">DIRECT SEND</span>
                            <span @click="openLinkModal(item.id?item.id:item.slug)" class="ws-button" v-tooltip="'Generate unique invitation link that you can share with your recipient to claim the gift.'">GENERATE LINK</span>
                        </div>
                        
                    </div>
                </div>
            </div>       
        </div> 
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "GiftBoxCampaignsEditModal",
    components: {Modal},
    props: {
        productId: Number,
        voucherBrand: String,
    },
    data() {
        return {
            loaded: false,
        }
    },
    methods: {
        openSendModal(id) {
            this.modals.marketplaceProductModal = false;
            this.$emit('open-send-modal', id);
        },
        openLinkModal(id) {
            this.modals.marketplaceProductModal = false;
            this.$emit('open-link-modal', id);
        },
    },
    async mounted() {
        this.$store.state.product.detail = null;
        if (this.productId) await this.dispatchWaitAndNotify('fetchMarketplaceProduct', {productId: this.productId}, false, true);
        else if (this.voucherBrand) await this.dispatchWaitAndNotify('fetchMarketplaceDigitalProduct', this.voucherBrand, false, true);
        this.loaded = true;
    },
    computed: {
        item() {
            return this.$store.state.product.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        team() {
            return this.$store.state.team.detail;
        },
    }
}
</script>

<style scoped>

</style>